import { Dispatch } from 'redux'
import * as ExerciseApi from './Exercise.api'
import * as ExerciseTypes from './Exercise.types'
import { throwErrorWithMessage } from 'api/apiMessages'

export const getExercisesByBookId = (bookId: string) => {
  return async (dispatch: Dispatch<ExerciseTypes.AsyncGetAllByBookId>) => {
    try {
      const response = await ExerciseApi.getExercisesByBookId(bookId)

      return dispatch({
        type: ExerciseTypes.ExerciseServiceActionTypes.AsyncGetAllByBookId,
        exerciseEntities: response.data,
        bookId
      })
    } catch (error) {
      return throwErrorWithMessage(error)
    }
  }
}

export const getDifficultWordsAndMasteredCount = () => {
  return async (dispatch: Dispatch<ExerciseTypes.AsyncGetDifficultWordsAndMasteredCount>) => {
    try {
      const { data } = await ExerciseApi.getDifficultWords()

      return dispatch({
        type: ExerciseTypes.ExerciseServiceActionTypes.AsyncGetDifficultWordsAndMasteredCount,
        difficultWords: data.difficultWords,
        masteredCount: data.masteredCount
      })
    } catch (error) {
      return throwErrorWithMessage(error)
    }
  }
}

export const createNewStudySet = (name: string, words?: string[]) => {
  return async (dispatch: Dispatch<ExerciseTypes.AsyncCreateNewStudySet>) => {
    try {
      const { data } = await ExerciseApi.createStudySet(name, words)

      return dispatch({
        type: ExerciseTypes.ExerciseServiceActionTypes.AsyncCreateNewStudySet,
        studySet: data
      })
    } catch (error) {
      return throwErrorWithMessage(error)
    }
  }
}

export const addWordToStudySet = (setId: string, word: string) => {
  return async (dispatch: Dispatch<ExerciseTypes.AsyncUpdateSingleStudySet>) => {
    try {
      const { data } = await ExerciseApi.addWordToStudySet(setId, word)

      return dispatch({
        type: ExerciseTypes.ExerciseServiceActionTypes.AsyncUpdateSingleStudySet,
        studySet: data
      })
    } catch (error) {
      return throwErrorWithMessage(error)
    }
  }
}

export const changeStudySetName = (setId: string, name: string) => {
  return async (dispatch: Dispatch<ExerciseTypes.AsyncUpdateSingleStudySet>) => {
    try {
      const { data } = await ExerciseApi.changeStudySetName(setId, name)

      return dispatch({
        type: ExerciseTypes.ExerciseServiceActionTypes.AsyncUpdateSingleStudySet,
        studySet: data
      })
    } catch (error) {
      return throwErrorWithMessage(error)
    }
  }
}

export const deleteWordFromStudySet = (setId: string, word: string) => {
  return async (dispatch: Dispatch<ExerciseTypes.AsyncUpdateSingleStudySet>) => {
    try {
      const { data } = await ExerciseApi.deleteWordFromStudySet(setId, word)

      return dispatch({
        type: ExerciseTypes.ExerciseServiceActionTypes.AsyncUpdateSingleStudySet,
        studySet: data
      })
    } catch (error) {
      return throwErrorWithMessage(error)
    }
  }
}

export const getStudySets = () => {
  return async (dispatch: Dispatch<ExerciseTypes.AsyncGetStudySets>) => {
    try {
      const { data } = await ExerciseApi.getStudySets()

      return dispatch({
        type: ExerciseTypes.ExerciseServiceActionTypes.AsyncGetStudySets,
        studySets: data.results
      })
    } catch (error) {
      return throwErrorWithMessage(error)
    }
  }
}

export const deleteStudySet = (setId: string) => {
  return async (dispatch: Dispatch<ExerciseTypes.DeleteStudySet>) => {
    try {
      await ExerciseApi.deleteStudySet(setId)

      return dispatch({
        type: ExerciseTypes.ExerciseServiceActionTypes.AsyncDeleteStudySet,
        setId
      })
    } catch (error) {
      return throwErrorWithMessage(error)
    }
  }
}

export const asyncGetMultipleByType = (type: ExerciseTypes.ExerciseType) => {
  return async (dispatch: Dispatch<ExerciseTypes.AsyncGetMultipleByType>) => {
    try {
      const response = await ExerciseApi.getExercisesByType(type)

      return dispatch({
        type: ExerciseTypes.ExerciseServiceActionTypes.AsyncGetMultipleByType,
        exerciseType: type,
        exerciseEntities: response.data
      })
    } catch (error) {
      return throwErrorWithMessage(error)
    }
  }
}

export const setCurrentStudySetId =
  (setId: string | null) => (dispatch: Dispatch<ExerciseTypes.SetCurrentStudySetId>) => {
    return dispatch({ type: ExerciseTypes.ExerciseServiceActionTypes.SetCurrentStudySetId, setId })
  }
